module.exports = __webpack_public_path__ + "img/suzhou.ab4e5b23.jpg";